// libs
import React, { memo } from 'react';

interface NykaaLogoProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function NykaaLogo({ width = 22, height = 24, fill = '#fff', className = '' }: NykaaLogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-123.000000, -127.000000)"
      >
        <path
          d="M144.325903,128.14704 C145.120115,126.623958 142.543079,127.056866 142.543079,127.056866 C141.609441,127.056866 141.194673,128.171452 141.004249,128.493692 L138.202635,133.970835 C137.670431,134.869897 135.941178,138.746537 135.355403,139.608632 C135.313762,138.738167 135.366398,136.988169 135.394938,136.571536 C135.508865,134.917326 135.624429,133.67045 135.796372,132.14946 C135.928779,130.974425 136.178857,129.65129 135.93416,128.477417 C135.781868,127.745287 135.53951,127.691348 134.484694,127.581377 C133.388471,127.466524 132.628881,129.062145 132.265111,129.807295 C130.917407,132.567488 129.414604,135.275603 128.217789,138.099733 C127.868757,138.922304 127.428724,139.74441 127.073375,140.564424 C126.647144,141.547882 126.240798,142.525296 125.774798,143.490852 C125.280725,144.513835 123.731369,147.842714 123.292973,148.887784 C122.814341,150.0312 122.714216,150.953047 124.639274,150.904688 C124.935904,150.89748 125.614084,150.974901 126.442918,150.082581 C127.089985,149.386023 127.222626,148.732012 127.611661,147.765525 C128.99118,144.338998 129.953826,142.057281 131.459437,138.669116 C131.609857,138.330369 131.945321,137.37295 132.278446,136.618035 C132.262304,137.68031 132.082174,138.955551 132.013396,139.797187 C131.761916,142.87404 131.578978,145.851153 131.310887,148.898246 C131.274861,149.307207 131.163508,149.797541 131.358844,150.183252 C131.551841,150.563616 132.022988,150.665682 132.416468,150.713111 C133.954128,150.897713 134.112736,150.14396 134.591602,149.089126 C135.01526,148.155886 135.27797,147.393067 135.659987,146.443785 C136.841363,143.508057 138.089878,140.597438 139.468227,137.747269 C139.819599,137.020486 140.177053,136.296261 140.555561,135.58273 C141.253391,134.266105 141.835657,133.022948 142.599223,131.566128 C143.165114,130.486183 143.719776,129.30952 144.325903,128.14704"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default memo(NykaaLogo);
